import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { LectureSeuleService } from "src/app/core/services/lecture-seule.service";

@Component({
	selector: "gm-icon-button",
	templateUrl: "./icon-button.component.html",
})
export class IconButtonComponent {
	@Output() clicked = new EventEmitter<void>();

	@Input() loading = false;
	@Input() disabled = false;
	@Input() color = "primary";
	@Input() icon = "ri-checkbox-circle-fill";
	@Input() hidden = false;
	@Input() ariaLabel = "";
	@Input() routerLink: any = null;
	@Input() class = "";
	/**
	 * La plupart de ces boutons servent à consulter (voir, imprimer, télécharger)
	 * et restent visibles. À passer à true pour une action d'écriture (modifier,
	 * supprimer, ajouter) : elle disparaît sur un écran en consultation seule.
	 */
	@Input() ecriture = false;

	private lectureSeuleService = inject(LectureSeuleService);

	get masque(): boolean {
		return this.ecriture && this.lectureSeuleService.isLectureSeule;
	}
}
